<template>
  <v-list-item>
    <v-list-item-content :style="{ padding: '9px 0' }">
      <v-list-item-title
        data-test-entity
        class="headline text-h6 font-weight-medium"
      >
        <slot></slot>
      </v-list-item-title>
      <v-list-item-subtitle>
        <div class="d-flex">
          <slot name="statusbar" />
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'AppEntityHeader'
};
</script>
